import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16ZM5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16ZM16 14C16.5128 14 16.9355 14.386 16.9933 14.8834L17 15V21L17.1166 21.0067C17.5757 21.06 17.94 21.4243 17.9933 21.8834L18 22C18 22.5128 17.614 22.9355 17.1166 22.9933L17 23H16C15.4872 23 15.0645 22.614 15.0067 22.1166L15 22V16C14.4477 16 14 15.5523 14 15C14 14.4872 14.386 14.0645 14.8834 14.0067L15 14H16ZM17.25 10.5C17.25 9.67157 16.5784 9 15.75 9C14.9216 9 14.25 9.67157 14.25 10.5C14.25 11.3284 14.9216 12 15.75 12C16.5784 12 17.25 11.3284 17.25 10.5Z"
	})
});
export default SvgInfo;
